import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { RouterModule } from '@angular/router';
import { HousingEditComponent } from './housing/housing-edit/housing-edit.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import {
  CarouselModule,
  ModalModule,
  PopoverModule,
  TabsModule,
  TooltipModule,
} from 'ngx-bootstrap';
import { AgmCoreModule } from '@agm/core';
import { BaseModule } from '../base/base.module';
import { SharedModule } from '../shared/shared/shared.module';
import { HousingInfoComponent } from './housing/housing-info/housing-info.component';
import { DetailsComponent } from './housing/housing-info/details/details.component';
import { StatisticsComponent } from './housing/housing-info/statistics/statistics.component';
import { HousingInfoDetailsBasicInfoComponent } from './housing/housing-info/details/basic-info/basic-info.component';
import { HousingInfoDetailsGoogleMapsComponent } from './housing/housing-info/details/google-maps/google-maps.component';
import { HousingInfoDetailsDistancesComponent } from './housing/housing-info/details/distances/distances.component';
import { HousingInfoDetailsRoomsComponent } from './housing/housing-info/details/rooms/rooms.component';
import { HousingInfoDetailsRatingComponent } from './housing/housing-info/details/rating/rating.component';
import { HousingInfoDetailsSourcesComponent } from './housing/housing-info/details/sources/sources.component';
import { HousingInfoDetailsInstantBookingComponent } from './housing/housing-info/details/instant-booking/instant-booking.component';
import { HousingInfoDetailsImagesComponent } from './housing/housing-info/details/images/images.component';
import { HousingInfoService } from '../services/housing-info/housing-info.service';
import { HousingInfoDetailsAmenitiesComponent } from './housing/housing-info/details/amenities/amenities.component';
import { ImageElementComponent } from './housing/housing-info/details/images/image-element/image-element.component';
import { LightboxModule } from 'ngx-lightbox';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { GoogleLocationMapper } from '../services/googlemapper/google-location-mapper.service';
import { ChartsModule } from 'ng2-charts';
import { PriceDataComponent } from './housing/housing-info/statistics/price-data/price-data.component';
import { ReportModule } from './admin/report/report.module';
import { ImageModalComponent } from './housing/housing-info/details/images/image-modal/image-modal.component';
import { HousingSearchModule } from './housing/housing-search/housing-search.module';
import { TopPartnerComponent } from './housing/housing-info/top-partner/top-partner.component';
import { RegistrationComponent } from './housing/housing-info/top-partner/registration/registration.component';
import { HousingAddComponent } from './housing/housing-add/housing-add.component';
import { HousingAddBasicInfoComponent } from './housing/housing-add/basic-info/basic-info.component';
import { HousingInfoDetailsCheckedByTeamComponent } from './housing/housing-info/details/checked-by-team/checked-by-team.component';
import { HousingRequestModule } from './housing-request/housing-request.module';
import { HousingInfoDetailsDeletedComponent } from './housing/housing-info/details/deleted/deleted.component';
import { HousingInfoModule } from './housing/housing-info/housing-info.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { HousingInfoDetailsClosedUntilComponent } from './housing/housing-info/details/closed-until/closed-until.component';
import { DeveloperModule } from './developer/developer.module';
import { AutoDisqualificationModule } from './request/auto-disqualification/auto-disqualification.module';
import { FollowUpModule } from './request/follow-up/follow-up.module';
import { HousingInfoDetailsChannelManagerComponent } from './housing/housing-info/details/channel-manager/channel-manager.component';
import { HousingInfoDetailsChannelManagerSettingsComponent } from './housing/housing-info/details/channel-manager-settings/channel-manager-settings.component';
import { BookingChangeRequestsComponent } from './admin/booking-change-requests/booking-change-requests.component';
import { ModalBookingChangeRequestsEditComponent } from './admin/booking-change-requests/modal/modal-booking-change-requests-edit.component';
import { CrawlHousingComponent } from './housing/housing-add/crawl-housing/crawl-housing.component';
import { ModalPhoneCallbackRequestEditComponent } from './admin/phone-callback/modal/modal-phone-callback-request-edit.component';
import { PhoneCallbackRequestComponent } from './admin/phone-callback/phone-callback-request.component';
import { UserSearchModule } from './user/user-search/user-search.module';
import { HousingInfoDetailsOnboardingTalksComponent } from './housing/housing-info/details/onboarding-talks/onboarding-talks.component';
import { OfferChangeRequestsComponent } from './admin/offer-change-requests/offer-change-requests.component';
import { ModalOfferChangeRequestsEditComponent } from './admin/offer-change-requests/modal/modal-offer-change-requests-edit.component';
import { HousingInfoDetailsCMOfferReservationsAvailableComponent } from './housing/housing-info/details/cm-offer-reservations-available/cm-offer-reservations-available.component';
import { DestinationOverrideListComponent } from './admin/destination-override/list/destination-override-list.component';
import { DestinationOverrideAddComponent } from './admin/destination-override/add/destination-override-add.component';
import { DestinationOverrideDetailsComponent } from './admin/destination-override/details/destination-override-details.component';
import { UserAddUserModalModule } from './user/user-add-modal/user-add-user-modal.module';
import { UserInfoModule } from './user/user-info/user-info.module';
import { DestinationSearchModule } from './pages/destination/destination-search.module';
import { DestinationInfoModule } from './pages/destination/destination-info/destination-info.module';
import { OfferMessagesComponent } from './admin/offer-messages/offer-messages.component';
import { ModalOfferMessagesEditComponent } from './admin/offer-messages/modal/modal-offer-messages-edit.component';
import { HousingInfoDetailsEmailSettingsComponent } from './housing/housing-info/details/email-settings/email-settings.component';
import { HousingInfoDetailsGoodiesComponent } from './housing/housing-info/details/goodies/goodies.component';
import { ModalHousingInfoDetailsGoodiesDetailsComponent } from './housing/housing-info/details/goodies/modals/modal-goodies-details.component';
import { HousingInfoDetailsWhitelabelConfigurationComponent } from './housing/housing-info/details/whitelabel-configuration/whitelabel-configuration.component';
import { RequestDetailsModule } from './request/request-details/details/request-details.module';
import { RequestSearchModule } from './request/request-details/search/request-search.module';
import { OfferDetailsModule } from './offer/offer-details/details/offer-details.module';
import { HousingInfoDetailsChannelManagerSettingsHyperguestComponent } from './housing/housing-info/details/channel-manager-settings-hyperguest/channel-manager-settings-hyperguest.component';
import { ModalChannelManagerSettingsHyperguestResponseComponent } from './housing/housing-info/details/channel-manager-settings-hyperguest/modal/modal-channel-manager-settings-hyperguest-response.component';
import { SiteCreationModule } from './pages/site-creation/site-creation.module';
import { BlKeywordSearchModule } from './pages/bl-keyword/bl-keyword-search.module';
import { BlKeywordInfoModule } from './pages/bl-keyword/bl-keyword-info/bl-keyword-info.module';
import { BlSearchModule } from './pages/bl/bl-search.module';
import { HousingInfoAccountSystem } from './housing/housing-info/details/info-accountsystem/info-accountsystem.component';
import { GeneratedTextDestinationModule } from './generated-text/destination/generated-text-destination.module';
import { GeneratedTextGetByKeysModule } from './generated-text/get-by-keys/generated-text-get-by-keys.module';
import { GeneratedTextBaseModule } from './generated-text/base/generated-text-base.module';
import { HousingInfoDetailsPaymentSettingsComponent } from './housing/housing-info/details/payment-settings/payment-settings.component';
import { HousingInfoDetailsAccountingComponent } from './housing/housing-info/details/accounting/accounting.component';
import { BookingPaymentPartnerComponent } from './admin/booking-payment-partner/booking-payment-partner.component';
import { AddDestinationComponent } from './bot/destinations/pages/add-destination/add-destination.component';
import { DestinationsInProgressComponent } from './bot/destinations/pages/destinations-in-progress/destinations-in-progress.component';
import { DestinationsFinishedComponent } from './bot/destinations/pages/destinations-finished/destinations-finished.component';
import { DestinationTableComponent } from './bot/destinations/components/destination-table/destination-table.component';
import { DestinationFilterComponent } from './bot/destinations/components/destination-filter/destination-filter.component';
import { BotMergeTransferFinishedStatsModal } from './bot/destinations/components/modal/bot-merge-transfer-finished-stats-modal/bot-merge-transfer-finished-stats-modal.component';
import { InProgressStatsModal } from './bot/destinations/components/modal/in-progress-stats-modal/in-progress-stats-modal.component';
import { ModalBookingPaymentPartnerEditComponent } from './admin/booking-payment-partner/modal/modal-booking-payment-partner-edit.component';
import { BookingPaymentComponent } from './admin/booking-payment/booking-payment.component';
import { ModalBookingPaymentDetailsComponent } from './admin/booking-payment/modals/modal-booking-payment-details/modal-booking-payment-details.component';
import { HousingInfoDetailsExpediaConnectComponent } from './housing/housing-info/details/expedia-connect/expedia-connect.component';

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HousingSearchModule,
    HousingInfoModule,
    UserInfoModule,
    UserSearchModule,
    GeneratedTextDestinationModule,
    GeneratedTextGetByKeysModule,
    GeneratedTextBaseModule,
    DestinationSearchModule,
    DestinationInfoModule,
    BlSearchModule,
    BlKeywordSearchModule,
    BlKeywordInfoModule,
    UserAddUserModalModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ReportModule,
    CarouselModule.forRoot(),
    TabsModule.forRoot(),
    PopoverModule.forRoot(),
    AgmCoreModule.forRoot(),
    TooltipModule.forRoot(),
    ModalModule.forRoot(),
    NgxPaginationModule,
    BaseModule,
    SharedModule,
    GooglePlaceModule,
    LightboxModule,
    ChartsModule,
    HousingRequestModule,
    AutoDisqualificationModule,
    FollowUpModule,
    DeveloperModule,
    RequestDetailsModule,
    RequestSearchModule,
    OfferDetailsModule,
    SiteCreationModule,
  ],
  declarations: [
    DashboardComponent,
    BookingChangeRequestsComponent,
    ModalBookingChangeRequestsEditComponent,
    ModalBookingPaymentPartnerEditComponent,
    BotMergeTransferFinishedStatsModal,
    OfferChangeRequestsComponent,
    ModalOfferChangeRequestsEditComponent,
    HousingEditComponent,
    HousingInfoComponent,
    /*hier müssen noch die housinginfocomponent, statistics etc umfunktionalisiert werden. wegen ngx pagination*/
    DetailsComponent,
    StatisticsComponent,
    HousingAddBasicInfoComponent,
    CrawlHousingComponent,
    HousingInfoAccountSystem,
    HousingInfoDetailsBasicInfoComponent,
    HousingInfoDetailsGoogleMapsComponent,
    HousingInfoDetailsDistancesComponent,
    HousingInfoDetailsRoomsComponent,
    HousingInfoDetailsRatingComponent,
    HousingInfoDetailsSourcesComponent,
    HousingInfoDetailsAccountingComponent,
    HousingInfoDetailsInstantBookingComponent,
    HousingInfoDetailsImagesComponent,
    HousingInfoDetailsAmenitiesComponent,
    HousingInfoDetailsCheckedByTeamComponent,
    HousingInfoDetailsEmailSettingsComponent,
    HousingInfoDetailsDeletedComponent,
    HousingInfoDetailsClosedUntilComponent,
    HousingInfoDetailsChannelManagerComponent,
    HousingInfoDetailsChannelManagerSettingsComponent,
    HousingInfoDetailsChannelManagerSettingsHyperguestComponent,
    HousingInfoDetailsPaymentSettingsComponent,
    ModalChannelManagerSettingsHyperguestResponseComponent,
    HousingInfoDetailsOnboardingTalksComponent,
    HousingInfoDetailsCMOfferReservationsAvailableComponent,
    HousingInfoDetailsWhitelabelConfigurationComponent,
    HousingInfoDetailsExpediaConnectComponent,
    ImageElementComponent,
    PriceDataComponent,
    ImageModalComponent,
    TopPartnerComponent,
    RegistrationComponent,
    HousingAddComponent,
    PhoneCallbackRequestComponent,
    ModalPhoneCallbackRequestEditComponent,
    DestinationOverrideListComponent,
    DestinationOverrideAddComponent,
    DestinationOverrideDetailsComponent,
    OfferMessagesComponent,
    ModalOfferMessagesEditComponent,
    HousingInfoDetailsGoodiesComponent,
    ModalHousingInfoDetailsGoodiesDetailsComponent,
    BookingPaymentPartnerComponent,
    AddDestinationComponent,
    DestinationsInProgressComponent,
    DestinationsFinishedComponent,
    DestinationTableComponent,
    DestinationFilterComponent,
    InProgressStatsModal,
    BookingPaymentComponent,
    ModalBookingPaymentDetailsComponent,
  ],
  providers: [HousingInfoService, GoogleLocationMapper],
  entryComponents: [BotMergeTransferFinishedStatsModal, InProgressStatsModal],
  exports: [],
})
export class DashboardModule {}
